/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EDateSearchType {
    Between = 'Between',
    Equals = 'Equals',
    NotEquals = 'NotEquals',
    GreaterThan = 'GreaterThan',
    LessThan = 'LessThan'
}


export function EDateSearchTypeFromJSON(json: any): EDateSearchType {
    return EDateSearchTypeFromJSONTyped(json, false);
}

export function EDateSearchTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EDateSearchType {
    return json as EDateSearchType;
}

export function EDateSearchTypeToJSON(value?: EDateSearchType | null): any {
    return value as any;
}

